<template>
  <div>备件流水</div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped></style>
